import type { ReactNode } from 'react'
import { LogoMark } from './ui.js'

/**
 * The way in — sign-in and the invitation — in the classroom's look: the
 * pale-blue field, one white card, the gold mark. Nothing to click away to.
 */
export function EntryCard({ children }: { children: ReactNode }) {
  return (
    <div className="cl flex min-h-dvh items-center justify-center !bg-class-field px-5 py-16">
      <div className="w-full max-w-[420px] rounded-class-lg bg-class-white px-7 py-9 shadow-[inset_0_0_0_1px_var(--color-class-hairline)] desk:px-10">
        <div className="mb-7 flex items-center gap-2.5">
          <LogoMark size={34} />
          <span className="font-class-display text-[18px] font-semibold">Diana</span>
        </div>
        {children}
      </div>
    </div>
  )
}
